import { Colors } from './Colors';
export const ButtonColorSchema = {
  big: {
    fontSize: 16,
    height: 48,
  },
  small: {
    fontSize: 16,
    height: 40,
  },
  primary: {
    background: {
      normal: Colors.primary,
      clicked: Colors.primaryDarker,
      hover: Colors.primary,
      disabled: Colors.greyLighter,
    },
    text: {
      normal: Colors.primaryWhite,
      clicked: Colors.primaryWhite,
      disabled: Colors.grey,
    },
    border: {
      normal: Colors.primary,
      clicked: Colors.primaryDarker,
      disabled: Colors.greyLight,
    },
    focus: Colors.secondary,
  },
  secondary: {
    background: {
      normal: Colors.primaryWhite,
      clicked: Colors.primaryDarker,
      hover: Colors.primaryLighter,
      disabled: Colors.primaryWhite,
    },
    text: {
      normal: Colors.primary,
      clicked: Colors.primaryWhite,
      hover: Colors.primary,
      disabled: Colors.grey,
    },
    border: {
      normal: Colors.primary,
      clicked: Colors.primaryDarker,
      hover: Colors.primary,
      disabled: Colors.greyLight,
    },
    focus: Colors.secondary,
  },
  tertiary: {
    background: {
      normal: Colors.primaryWhite,
      clicked: Colors.primaryDarker,
      hover: Colors.primaryLighter,
      disabled: Colors.primaryWhite,
    },
    text: {
      normal: Colors.darkBlack,
      clicked: Colors.primaryWhite,
      hover: Colors.primary,
      disabled: Colors.grey,
    },
    border: {
      normal: Colors.greyLight,
      clicked: Colors.primaryDarker,
      hover: Colors.primary,
      disabled: Colors.greyLight,
    },
    focus: Colors.secondary,
  },
  tertiaryIcon: {
    background: {
      normal: Colors.primaryWhite,
      hover: Colors.primaryWhite,
      disabled: Colors.primaryWhite,
      clicked: Colors.greyLighter,
    },
    text: {
      normal: Colors.darkBlack,
      hover: Colors.darkBlack,
      clicked: Colors.darkBlack,
      disabled: Colors.grey,
      icon: Colors.greyDark,
    },
    border: {
      normal: Colors.greyLight,
      clicked: Colors.greyLight,
      hover: Colors.greyLight,
      disabled: Colors.greyLight,
    },
    focus: Colors.secondary,
  },
};
